import styled from 'styled-components';
import { Box, Text } from '@rsos/base-components';

interface AccordionHeaderProps {
  isExpanded?: boolean;
}

interface CaretWrapperProps {
  isExpanded?: boolean;
}

export const CustomAccordionWrapper = styled(Box).attrs({
  borderRadius: 1,
  marginBottom: 1,
  border: '1px solid',
  borderColor: 'lightLineDivider',
})``;

export const CustomAccordionHeader = styled(Box).attrs(
  ({ isExpanded }: AccordionHeaderProps) => ({
    horizontal: true,
    align: 'center',
    padding: '2px 8px',
    justify: 'space-between',
    bg: 'background',
    borderRadius: isExpanded ? '4px 4px 0 0' : 1,
    cursor: 'pointer',
  }),
)<AccordionHeaderProps>`
  &:hover {
    background: ${({ theme }) => theme.colors.foreground};
  }
`;

export const CustomAccordionContent = styled(Box).attrs({
  padding: '8px 12px 12px 32px',
  bg: 'background',
  borderRadius: '0 0 4px 4px',
})``;

export const LayerNameText = styled(Text).attrs({
  color: 'primaryText',
  size: 'small',
  ellipsis: true,
})`
  flex: 1;
  margin-right: 8px;
  min-width: 0;
`;

export const CaretWrapper = styled(Box).attrs({
  align: 'center',
  justify: 'center',
  width: '16px',
  height: '16px',
})<CaretWrapperProps>`
  transition: transform 0.4s ease;
  transform: ${({ isExpanded }) =>
    isExpanded ? 'rotate(-180deg)' : 'rotate(0deg)'};
`;

export const RegularCheckboxWrapper = styled(Box).attrs({
  padding: '0px 9px', // 1px for border match
  bg: 'background',
})`
  &:hover {
    background: ${({ theme }) => theme.colors.foreground};
  }
`;
